import React from "react";
import { Grid, Button, Typography, makeStyles } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewTwoToneIcon from "@mui/icons-material/ArrowBackIosNewTwoTone";
import { connect } from "react-redux";

const useStyles = makeStyles(() => ({
  Typography: {
    padding: "1rem",
    textAlign: "justify",
    lineHeight: "normal",
  },
}));

 function RefundAndCancellation(props) {

	const [storeInfo, setStoreInfo] = React.useState("");

  // const { reducer } = props;
  // const storeInfo = props.sessionReducer?.store_details;


  let StoreConfig = localStorage.getItem("jwt");
 let config=JSON.parse(StoreConfig)

React.useEffect(() => {
  setStoreInfo(config?.store)
}, [StoreConfig])

  const navigate = useNavigate();
  const classes = useStyles();
  return (
    <Grid style={{ background: "#f1f1f1", height: "100vh" }}>
      <Grid
        style={{
          padding: "0.8rem",
          boxShadow: "0px 0px 9px",
          background: "white",
        }}
      >
        <Button
          onClick={() => {
            navigate(-1);
          }}
          style={{
            position: "absolute",
            left: 0,
          }}
        >
          <ArrowBackIosNewTwoToneIcon />
        </Button>
        <Typography variant="h5" style={{ fontWeight: "bold" }}>
          Refund and Cancellation
        </Typography>
      </Grid>
      <Grid
        style={{
          padding: "1rem",
          marginTop: "1rem",
          maxHeight: "85vh",
          overflow: "scroll",
          scrollbarWidth: "none",
        }}
      >
        <Typography className={classes.Typography}>
           
          As a general rule you shall not be entitled to cancel your order once
          you have received confirmation of the same. If you cancel your order
          after it has been confirmed,<span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span>shall have a right to charge
          you cancellation fee of a minimum INR 25 upto the order value, with a
          right to either not to refund the order value or recover from your
          subsequent order, the complete/ deficit cancellation fee, as
          applicable, to compensate our restaurant. <span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span> shall also have
          right to charge you cancellation fee for the orders cancelled by
          <span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span> for the reasons specified under clause 1(3) of this
          cancellation and refunds policy. In case of cancellations for the
          reasons attributable to <span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span> , <span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span> shall not
          charge you any cancellation fee. 
        </Typography>

        <Typography className={classes.Typography}>
          However, in the unlikely event of an item on your order being
          unavailable, we will contact you on the phone number provided to us at
          the time of placing the order and inform you of such unavailability.
          In such an event you will be entitled to cancel the entire order and
          shall be entitled to a refund in accordance with our refund policy.
        </Typography>

        <Typography className={classes.Typography}>
           
          We reserve the sole right to cancel your order in the following
          circumstance: 
        </Typography>
        <div className="mb-3 pl-3">
          <Typography className={classes.Typography}>
            In the event of the designated address falls outside the delivery
            zone offered by us;
          </Typography>
          <Typography className={classes.Typography}>
            Failure to deliver your order due to lack of information, direction
            or authorization from you at the time of delivery.
          </Typography>
        </div>

        <Typography
          className={classes.Typography}
          style={{ fontWeight: "bold", paddingBottom: "0rem" }}
        >
           
          Refund 
        </Typography>
        <ul>
          <li>
             
            <Typography
              className={classes.Typography}
              style={{ padding: "0.5rem" }}
            >
              You shall be entitled to a refund only if you pre-pay for your
              order at the time of placing your order on the Platform and only
              in the event of any of the following circumstances:
            </Typography>
          </li>
          <li>
             
            <Typography
              className={classes.Typography}
              style={{ padding: "0.5rem" }}
            >
              Your order packaging has been tampered or damaged at the time of
              delivery.
            </Typography>
          </li>
          <li>
             
            <Typography
              className={classes.Typography}
              style={{ padding: "0.5rem" }}
            >
               
              <span style={{textTransform:"uppercase"}}> {storeInfo?.store_org_name} </span> cancelling your order due to (A) your delivery location
              following outside our designated delivery zones; (B) failure to
              contact you by phone or email at the time of confirming the order
              booking.
            </Typography>
          </li>
          <li>
             
            <Typography
              className={classes.Typography}
              style={{ padding: "0.5rem" }}
            >
              You cancelling the order at the time of confirmation due to
              unavailability of the items you ordered for at the time of
              booking.
            </Typography>
          </li>
          <li>
             
            <Typography
              className={classes.Typography}
              style={{ padding: "0.5rem" }}
            >
              Our decision on refunds shall be at our sole discretion and shall
              be final and binding.
            </Typography>
          </li>

          <li>
             
            <Typography className={classes.Typography}>
              All refund amounts shall be credited to your account within 5-7 working days in accordance with the terms that may be stipulated
              by the bank which has issued the credit / debit card.
            </Typography>
          </li>
        </ul>
      </Grid>
    </Grid>
  );
}
const mapStateToProps = (state) => {
  return {
    reducer: state.customerReducer,
  };
};

export default connect(mapStateToProps)(RefundAndCancellation);

